<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">
        Add Policy
      </span>
    </div>
    <transition name="slide-up">
      <template v-if="!isLoading">
        <PolicyForm :policy="policy" @submit="onSubmit($event)" />
      </template>
    </transition>
  </div>
</template>

<script>
  import PolicyService from '../services/policy.service';
  import PolicyForm from './PolicyForm';
  import { consumePolicyPrefillFromRoute } from '@shared/utils/policyPrefill';
  export default {
    name: 'PolicyAdd',
    components: {
      PolicyForm
    },
    data() {
      return {
        policy: {},
        isLoading: true
      };
    },
    mounted() {
      this.policy = {
        name: '',
        description: '',
        text_string_appear: '',
        text_string_not_appear: '',
        rules: [
          {
            type: 'HREF',
            action: 'Do not monitor',
            condition: 'Contains',
            field: '',
            severity: 10
          }
        ],
        url_ids: []
      };

      const prefill = consumePolicyPrefillFromRoute(
        this.$router,
        this.$route,
        (payload) => payload && payload.mode === 'new'
      );
      if (prefill) {
        this.policy = {
          ...this.policy,
          rules:
            Array.isArray(prefill.rules) && prefill.rules.length
              ? prefill.rules
              : this.policy.rules,
          url_ids: Array.isArray(prefill.url_ids)
            ? prefill.url_ids
            : this.policy.url_ids
        };
      }

      this.isLoading = false;
    },
    methods: {
      onSubmit(event) {
        PolicyService.create(event).then(() => {
          this.$router.push('/policy/list');
          this.$showSuccessMessage('Added Policy');
        });
      }
    }
  };
</script>
